import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';
import { Button, TextLink, AlertDialog } from '@ds/react-components';
import * as config from 'common/config';
import { ContactIcon } from './ContactIcon';

const styles = (theme) => ({
  root: {},
  contactIcon: {
    width: 80,
    height: 80,
    lineHeight: '110px',
    margin: '0 auto',
    backgroundColor: theme.palette.common.primary,
    borderRadius: '50%',
    marginBottom: theme.spacing(2),
  },
  title: {
    textAlign: 'center',
    '& hr': {
      marginTop: theme.spacing(3),
      border: `0.5px solid ${theme.palette.common.inputBorder}`,
    },
    padding: '0 24px',
  },
  content: {
    textAlign: 'center',
    padding: '0 24px',
    '& h4': {
      marginBottom: theme.spacing(2),
    },
    '& hr': {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      border: `0.5px solid ${theme.palette.common.inputBorder}`,
    },
  },
  footer: {
    textAlign: 'center',
    width: '100%',
    '& button': {
      width: '100%',
    },
    padding: '0 24px',
  },
  contacts: {},
});

class ContactDialog extends React.PureComponent {
  state = {
    openContactDialog: false,
  };

  handleOpenClose = () => {
    const dialog = this.state.openContactDialog;
    this.setState({ openContactDialog: !dialog });
  };

  render() {
    const { classes, linkText } = this.props;
    const locale = config.locale.toLowerCase();
    const title = (
      <div className={classes.title}>
        <div className={classes.contactIcon}>
          <ContactIcon />
        </div>
        <Typography variant="h3">Contact us</Typography>
        <hr />
      </div>
    );
    const content =
      locale === 'en-nz' || locale === 'en-aus' ? (
        <div className={classes.content}>
          <div className={classes.contacts}>
            <Typography variant="h4">In New Zealand</Typography>
            <Typography>
              Free Call: <a href="tel:0800 481 0400">0800 481 0400</a>
            </Typography>
            <Typography>
              Email:{' '}
              <a href="mailto:customerservice@debitsuccess.co.nz">
                customerservice@debitsuccess.co.nz
              </a>
            </Typography>
            <Typography>Monday to Friday: 10.30am - 7pm</Typography>
          </div>
          <hr />
          <div className={classes.contacts}>
            <Typography variant="h4">In Australia</Typography>
            <Typography>
              Free Call: <a href="tel:1800 148 848">1800 148 848</a>
            </Typography>
            <Typography>
              Email:{' '}
              <a href="mailto:customerservice@debitsuccess.com">
                customerservice@debitsuccess.com
              </a>
            </Typography>
            <Typography>Monday to Friday: 8.30am - 5pm</Typography>
          </div>
        </div>
      ) : null;
    const action = (
      <div className={classes.footer}>
        <Button onClick={this.handleOpenClose} text="Close" />
      </div>
    );
    return (
      <React.Fragment>
        <TextLink to={'#'} onClick={this.handleOpenClose}>
          {linkText || 'contact us'}
        </TextLink>
        <AlertDialog
          title={title}
          text={content}
          actions={action}
          open={this.state.openContactDialog}
          redirectLink={'#'}
          handleAlertClose={this.handleOpenClose}
        />
      </React.Fragment>
    );
  }
}

ContactDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  linkText: PropTypes.string,
  localisation: PropTypes.object,
};

export default withStyles(styles)(ContactDialog);
